module.exports = __webpack_public_path__ + "media/assets/images/close-b0200bf7cbbb26c32989e7a0e4d19eef.svg";